import MyTinySlider from './MyTinySlider';
import { onDomReady } from '../../components/dynamic/observer';

onDomReady(() => {
  if (!document.querySelector('[data-layout-ways-slider-container]')) {
    return;
  }
  const layoutWaysSlider = new MyTinySlider({
    sliderContainer: '[data-layout-ways-slider-container]',
    sliderList: '[data-layout-ways-slider]',
    arrowLeft: '[data-layout-ways-left]',
    arrowRight: '[data-layout-ways-right]',
    slideIndex: '[data-layout-ways-slider-index]',
    slideCount: '[data-layout-ways-count]',
    slideBy: 1,
    nav: true,
    navPosition: 'bottom',
    speed: 700,
    center: true,
    controls: false,
    rewind: true,
    loop: false,
    responsive: {
      0: {
        gutter: 12,
        fixedWidth: 302,
      },
      768: {
        gutter: 24,
        fixedWidth: 333,
      },
      1280: {
        gutter: 28,
        fixedWidth: 380,
      },
    },
  });
});